// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__j9WTS","text":"Breadcrumb_text__jU0i0"};